// extracted by mini-css-extract-plugin
export var backupIcon = "_nv-1";
export var image = "_nv-0";